const versions = [
	{
		label: "MEPC.369(80)",
		value: "MEPC.369(80)",
	},
	{
		label: "MEPC 76",
		value: "MEPC 76",
	},
];

export default versions;
